var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutList",
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c("img", {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: _vm.resource.country.name,
                expression: "resource.country.name",
              },
            ],
            staticClass: "flag",
            attrs: {
              src: _vm.resource.country.flag || "//placehold.it/32x21",
              alt: _vm.resource.country.name,
            },
          }),
          _vm._v(" "),
          _c("h1", [_vm._v(_vm._s(_vm.resource.name || " "))]),
          _vm._v(" "),
          _vm.resource.can.edit
            ? _c(
                "router-link",
                {
                  staticClass: "btn btn--primary",
                  attrs: {
                    to: {
                      name: "edit-member-form",
                      params: { id: _vm.resource.id },
                    },
                  },
                },
                [_vm._v("\n                Edit\n            ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("ul", { staticClass: "grid post-details" }, [
            _vm.resource.phone
              ? _c(
                  "li",
                  { staticClass: "col-12 col-md-2 col-bleed-y detail" },
                  [
                    _c("span", { staticClass: "label" }, [_vm._v("Telephone")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      { attrs: { href: "tel:" + _vm.resource.phone } },
                      [
                        _c("SvgIcon", { attrs: { icon: "phone" } }),
                        _vm._v(_vm._s(_vm.resource.phone)),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resource.website
              ? _c(
                  "li",
                  { staticClass: "col-12 col-md-2 col-bleed-y detail" },
                  [
                    _c("span", { staticClass: "label" }, [_vm._v("Website")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.sanitizeUrl(_vm.resource.website),
                          target: "_blank",
                        },
                      },
                      [
                        _c("SvgIcon", { attrs: { icon: "link" } }),
                        _vm._v("Website\n                    "),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vue-tabs",
        { ref: "tabs", on: { "tab-change": _vm.onTabChange } },
        [
          _c(
            "v-tab",
            { attrs: { id: "people", title: "People" } },
            [_c("GridUsers", { attrs: { filters: _vm.peopleFilters } })],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "opportunities", title: "Opportunities" } },
            [
              _c("div", { staticClass: "toolbar" }, [
                _c("fieldset", { staticClass: "toolbar__filters" }, [
                  _c(
                    "div",
                    { staticClass: "flex-fix" },
                    [
                      _c("FormControlSector", {
                        attrs: {
                          name: "sectors",
                          multiple: true,
                          "include-ancestors": false,
                        },
                        model: {
                          value: _vm.oppFilters.sectors,
                          callback: function ($$v) {
                            _vm.$set(_vm.oppFilters, "sectors", $$v)
                          },
                          expression: "oppFilters.sectors",
                        },
                      }),
                      _vm._v(" "),
                      _c("FormControlDealType", {
                        attrs: { name: "dealType" },
                        model: {
                          value: _vm.oppFilters.dealType,
                          callback: function ($$v) {
                            _vm.$set(_vm.oppFilters, "dealType", $$v)
                          },
                          expression: "oppFilters.dealType",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("fieldset", { staticClass: "toolbar__search" }, [
                  _c("div", { staticClass: "flex-fix" }, [
                    _c("div", { staticClass: "form__group search" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form__label",
                          attrs: { for: "opp-search" },
                        },
                        [_vm._v("Search Opportunities")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.oppFilters.query,
                            expression: "oppFilters.query",
                          },
                        ],
                        staticClass: "form__control search",
                        attrs: {
                          id: "opp-search",
                          type: "search",
                          placeholder: "Search Opportunities...",
                        },
                        domProps: { value: _vm.oppFilters.query },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.oppFilters,
                              "query",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("ListOpportunities", {
                ref: "opportunities",
                attrs: { "load-on-start": false, filters: _vm.oppFilters },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "madds", title: "MADDs" } },
            [
              _c("div", { staticClass: "toolbar" }, [
                _c("fieldset", { staticClass: "toolbar__filters" }, [
                  _c(
                    "div",
                    { staticClass: "flex-fix" },
                    [
                      _c("FormControlSector", {
                        attrs: {
                          name: "sectors",
                          multiple: true,
                          "include-ancestors": false,
                        },
                        model: {
                          value: _vm.maddFilters.sectors,
                          callback: function ($$v) {
                            _vm.$set(_vm.maddFilters, "sectors", $$v)
                          },
                          expression: "maddFilters.sectors",
                        },
                      }),
                      _vm._v(" "),
                      _c("FormControlDealType", {
                        attrs: { name: "dealType" },
                        model: {
                          value: _vm.maddFilters.dealType,
                          callback: function ($$v) {
                            _vm.$set(_vm.maddFilters, "dealType", $$v)
                          },
                          expression: "maddFilters.dealType",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("fieldset", { staticClass: "toolbar__search" }, [
                  _c("div", { staticClass: "flex-fix" }, [
                    _c("div", { staticClass: "form__group search" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form__label",
                          attrs: { for: "madd-search" },
                        },
                        [_vm._v("Search Opportunities")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.maddFilters.query,
                            expression: "maddFilters.query",
                          },
                        ],
                        staticClass: "form__control search",
                        attrs: {
                          id: "madd-search",
                          type: "search",
                          placeholder: "Search MADDs...",
                        },
                        domProps: { value: _vm.maddFilters.query },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.maddFilters,
                              "query",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("ListMADDs", {
                ref: "madds",
                attrs: { "load-on-start": false, filters: _vm.maddFilters },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "insights", title: "Insights" } },
            [
              _c("div", { staticClass: "toolbar" }, [
                _c("fieldset", { staticClass: "toolbar__filters" }, [
                  _c(
                    "div",
                    { staticClass: "flex-fix" },
                    [
                      _c("FormControlSector", {
                        attrs: {
                          name: "sectors",
                          multiple: true,
                          "include-ancestors": false,
                        },
                        model: {
                          value: _vm.insFilters.sectors,
                          callback: function ($$v) {
                            _vm.$set(_vm.insFilters, "sectors", $$v)
                          },
                          expression: "insFilters.sectors",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("fieldset", { staticClass: "toolbar__search" }, [
                  _c("div", { staticClass: "flex-fix" }, [
                    _c("div", { staticClass: "form__group search" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form__label",
                          attrs: { for: "int-search" },
                        },
                        [_vm._v("Search Insights")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.insFilters.query,
                            expression: "insFilters.query",
                          },
                        ],
                        staticClass: "form__control search",
                        attrs: {
                          id: "int-search",
                          type: "search",
                          placeholder: "Search Insights...",
                        },
                        domProps: { value: _vm.insFilters.query },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.insFilters,
                              "query",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("ListInsights", {
                ref: "insights",
                attrs: { "load-on-start": false, filters: _vm.insFilters },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }